import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { DashboardFiltersComponent } from './dashboard-filters/dashboard-filters.component';
import { DashboardFooterComponent } from './dashboard-footer/dashboard-footer.component';
import { DashboardMainComponent } from './dashboard-main/dashboard-main-component';
import { DashboardOriginsComponent } from './dashboard-origins/dashboard-origins.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { DashboardRightComponent } from './dashboard-right/dashboard-right.component';
import { DashboardAVCModule } from './dashboard-avc/dashboard-avc.module';
import { TitleBarModule, SpinnerModule, DfMonthPickerModule, LoadingErrorModule, PipesModule, StoreProviderModule, MenuModule, ExceptionsModule } from '@uxdf/direct-shared-lib';
import { FormGroupModule, NavbarModule, ConfirmAlertModule } from '@uxdf/p-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { LoyaltyModule } from '../loyalty/loyalty.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbCompatModule } from '@uxdf/direct-shared-lib';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DfSelectModule, DfMediaModule, DfAlertModule, DfDatePickerModule, DfInsertIconModule, DfModule } from '@design-factory/design-factory';
import { CsvModule } from '@ctrl/ngx-csv';
import { ReefI18nModule, ReefAppModule, NgbDateIataFormatter } from '@seco/core';
import { AnalyticsModule } from '@seco/dev-utils';
import { DoughnutChartModule } from '../../directives/doughnutChart.module';

@NgModule({
  declarations: [DashboardFiltersComponent,
    DashboardFooterComponent,
    DashboardMainComponent,
    DashboardOriginsComponent,
    DashboardPageComponent,
    DashboardRightComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    DashboardAVCModule,
    TitleBarModule,
    FormGroupModule,
    FormsModule,
    NgSelectModule,
    SpinnerModule,
    DfMonthPickerModule,
    FeatureToggleModule,
    NgxPermissionsModule.forRoot(),
    NgbCompatModule,
    NavbarModule,
    ConfirmAlertModule,
    LoadingErrorModule,
    PipesModule,
    ReactiveFormsModule,
    NgxPageScrollModule,
    StoreProviderModule,
    MenuModule,
    ExceptionsModule,
    DfSelectModule,
    CsvModule,
    ReefI18nModule.forRoot(),
    DfMediaModule,
    ReefAppModule.forRoot(),
    AnalyticsModule,
    DoughnutChartModule,
    DfAlertModule,
    DfInsertIconModule,
    LoyaltyModule,
    DfDatePickerModule,
    CommonModule,
    DfModule
  ],
  exports: [DashboardMainComponent]
})
export class DashboardModule {}